/**
 * The reading text size: a multiplier on prose, never on the app's chrome
 * (v1.91). **Translated from v1's `frontend/src/lib/textScale.js`, with its
 * tests** (`frontend.md` Q3 (a)). The ladder is rungs, not a zoom: a stepper
 * wants places to reach and return to, and 1 is exactly 1.
 *
 * The value lives in `prefs/store.ts`, per browser and per person (F4); only
 * `styles/prose.css` reads the `--prose-scale` it sets.
 */

export const SCALES = [0.9, 1, 1.15, 1.3, 1.5, 1.75] as const;
export const DEFAULT_SCALE = 1;

/** Move `steps` rungs from `current`, held at both ends. */
export function stepScale(current: number, steps: number): number {
  const i = SCALES.indexOf(current as (typeof SCALES)[number]);
  const from = i === -1 ? SCALES.indexOf(DEFAULT_SCALE) : i;
  return SCALES[Math.min(SCALES.length - 1, Math.max(0, from + steps))] ?? DEFAULT_SCALE;
}

/** A stored value, if it is a rung; else the default. */
export function parseScale(stored: string | null): number {
  const value = Number.parseFloat(stored ?? "");
  return (SCALES as readonly number[]).includes(value) ? value : DEFAULT_SCALE;
}

/** How far a pinch must travel before it moves one rung (v1.99). */
export const PINCH_STEP = 1.18;

/**
 * Which way a pinch steps — -1, 0 or +1 — given how far the fingers are apart
 * now and when it last stepped. The caller takes a new baseline after a step,
 * so a long pinch keeps stepping.
 */
export function pinchStep(distance: number, baseline: number): -1 | 0 | 1 {
  if (!(distance > 0) || !(baseline > 0)) return 0;
  const ratio = distance / baseline;
  if (ratio > PINCH_STEP) return 1;
  if (ratio < 1 / PINCH_STEP) return -1;
  return 0;
}
